/** The token of a reply link (/rsvp/{token}), or undefined for any other address. */
export const rsvpToken = (path: string) => /^\/rsvp\/([A-Za-z0-9_-]{16,32})\/?$/.exec(path)?.[1];
